<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KX9nnW/tc-custom/9781526738981.jpg?1728293326316" alt="This image is the cover for the book Britain's Second-Hand Trams"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Britain's Second-Hand Trams
      </h1>
      <p class="bookDescription body article font2">
        <p>During the history of Britain’s electric tramcar fleets, many thousands were manufactured of which the vast majority saw out their operational life with a single owner. However, for several hundred there was to be a second – if not, in certain cases, a third – career with a new operator.  Almost from the dawn of the electric era in the late 19th century tramcars were loaned or bought and sold between operators. The reasons for this were multifarious. Sometimes the aspirations of the original owners for traffic proved wildly optimistic and the fleet was downsized to reflect better the actual passenger levels. War was a further cause as operators sought to strengthen their fleets to cater for unexpectedly high level of demand or to replace trams destroyed by enemy action. For other operators, modernization represented an opportunity to sell older cars while, certainly from the 1930s, a number of operators – such as Aberdeen, Leeds and Sunderland – took advantage of the demise of tramways elsewhere to supplement their fleet with trams that were being withdrawn but which still had many years of useful operational life in them. The process was to continue right through to the mid-1950s when Glasgow took advantage of the demise of the once-extensive Liverpool system to purchase a number of the streamlined bogie bogie cars that were built in the late 1930s.  In this book the author provides a pictorial history – with detailed captions – to the many electric trams that were to operate with more than one tramway during the period up to the closure of the closure of the Glasgow system in 1962.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Waller
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pen and Sword Transport
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?13abeea3